module.exports = __webpack_public_path__ + "img/sdn.9ad0597.svg";